// global constants

export const REGEX_HEXCOLOR = /^#([a-fA-F0-9]{6})$/;
export const PAGE_SIZE_OPTIONS = [10, 25, 100];

export enum Routes {
  AuthSignIn = "/auth/signin",
  AuthSignUp = "/auth/signup",
  AuthEmailConfirmation = "/auth/email-confirmation",
  AuthResendEmailConfirmation = "/auth/resend-email-confirmation",
  AuthResetPassword = "/auth/reset-password",
  StatsDashboard = "/stats",
  AuthResetPasswordConfirmation = "/auth/reset-password-confirmation",
}

export enum ColumnKeyEnum {
  record_id= "record_id",
  cohort_individual_id= "cohort_individual_id",
  first_name= "first_name",
  last_name= "last_name",
  registry_title= "registry_title",
  registry_id= "registry_id",
  age = "age",
  ethnicity = "race_cdisc",
  sex_at_birth = "sex_at_birth",
  created_date = "date_account_created",
  country= "country",
  aa_id= "aa_id",
  aa_position= "aa_position",
}


export enum PublicDashboardUrlParams {
  hideCharts= "hideCharts",
  registry= "registry",
  switch= "switch",
}
